module.exports = __webpack_public_path__ + "static/media/prpg3.6bf87698.png";